import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NoteTemplateComponent } from './note-template-component/note-template.component';

const routes: Routes = [
  {
    path: 'notetemplate',
    component: NoteTemplateComponent,
    data: {
      title: 'Note Template'
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class NoteTemplateRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/pages/note-template/note-template-routing.module.ts